import App from 'app/app.js';
import 'app/service/EventService.js';

function MessageChangeAction(EventService) {
  this.eventName = 'messageChange';

  this.dispatch = function (message) {
    EventService.dispatch(this.eventName, message);
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('MessageChangeAction', ['EventService', MessageChangeAction]);
